import BluebirdPromise from 'bluebird';
import { has, isEqual } from 'lodash';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { RuntimeContext } from '../../../../common/RuntimeContext';
import { getBehavior, postBehavior, putBehavior } from '../../../shared/actions';
import Page from '../../../shared/components/Page';
import PageContent from '../../../shared/components/PageContent';
import PageHeader from '../../../shared/components/PageHeader';
import BehaviorForm from '../forms/BehaviorForm';

class AddOrEditBehavior extends Component {
    static propTypes = {
        getBehavior: PropTypes.func.isRequired,
        postBehavior: PropTypes.func.isRequired,
        putBehavior: PropTypes.func.isRequired,

        currentBehavior: PropTypes.object,
        match: PropTypes.object,
        history: PropTypes.object
    };

    static contextType = RuntimeContext;

    constructor(props) {
        super(props);

        this.state = {
            selectedDimensionId: {},
            selectedAbility: {},
            abilitySelectOptions: []
        };
    }

    componentDidMount() {
        const {
            match: { params },
            getBehavior
        } = this.props;

        if (params && params.id) {
            getBehavior({ id: params.id, pathsContext: this.context.pathsWeb });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.id !== prevProps.match.params.id) {
            this.props.getBehavior({ id: this.props.match.params.id, pathsContext: this.context.pathsWeb });
        }
    }

    handleSubmit = (values) => {
        const { currentBehavior, putBehavior, postBehavior, history } = this.props;
        const newBehavior = {
            ...currentBehavior,
            ...values
        };

        let submitPromise;

        if (!has(newBehavior, '_id')) {
            submitPromise = postBehavior({
                body: newBehavior,
                pathsContext: this.context.pathsWeb
            });
        } else if (!isEqual(newBehavior, currentBehavior)) {
            submitPromise = putBehavior({
                id: newBehavior._id,
                body: newBehavior,
                pathsContext: this.context.pathsWeb
            });
        } else {
            submitPromise = BluebirdPromise.resolve();
        }
        return submitPromise.then(() => {
            history.push('/managecontentframework');
        });
    };

    handleCancel = () => {
        const { history } = this.props;
        return history.push('/managecontentframework');
    };

    render() {
        const {
            match: { path },
            currentBehavior = {}
        } = this.props;
        const title = path === '/newbehavior' ? 'Create New Behavior' : 'Edit Behavior Details';

        return (
            <Page>
                <PageHeader title={title} hideBackButton={true} />
                <PageContent>
                    <BehaviorForm
                        currentBehavior={currentBehavior}
                        onSubmit={this.handleSubmit}
                        onCancel={this.handleCancel}
                    />
                </PageContent>
            </Page>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const {
        auth: { isAuthenticated },
        behaviors
    } = state;
    const behaviorId = ownProps.match.params.id;
    const currentBehavior = behaviorId ? behaviors.byId[behaviorId] : {};
    return {
        isAuthenticated,
        currentBehavior
    };
};

const mapDispatchToProps = (dispatch) => ({
    getBehavior: (params) => dispatch(getBehavior(params)),
    postBehavior: (params) => dispatch(postBehavior(params)),
    putBehavior: (params) => dispatch(putBehavior(params))
});

export const AddOrEditBehaviorComponent = AddOrEditBehavior;
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddOrEditBehavior));
